(function () {
  function cleanNumber(value) {
    var number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return isNaN(number) ? 0 : number;
  }

  function formatMoney(number) {
    return '$' + Math.round(number).toLocaleString('en-US');
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var modeButtons = root.querySelectorAll('[data-bs-mode]');
    var modalModeButtons = root.querySelectorAll('[data-bs-modal-mode]');
    var options = root.querySelectorAll('[data-bs-option]');
    var stickyPrice = root.querySelector('[data-bs-sticky-price]');
    var stickySuffix = root.querySelector('[data-bs-sticky-suffix]');
    var stickyCaption = root.querySelector('[data-bs-sticky-caption]');
    var downInput = root.querySelector('[data-bs-down-input]');
    var termSelect = root.querySelector('[data-bs-term-select]');
    var financeSummaryText = root.querySelector('[data-bs-finance-summary-text]');
    var openFinancingButtons = root.querySelectorAll('[data-bs-open-financing]');
    var closeFinancingButtons = root.querySelectorAll('[data-bs-close-financing]');
    var openCompareButtons = root.querySelectorAll('[data-bs-open-compare]');
    var closeCompareButtons = root.querySelectorAll('[data-bs-close-compare]');
    var modalPayment = root.querySelector('[data-bs-modal-payment]');
    var modalPaymentSuffix = root.querySelector('[data-bs-modal-payment-suffix]');
    var modalApr = root.querySelector('[data-bs-modal-apr]');
    var orderLink = root.querySelector('[data-bs-order-link]');

    var captions = {
      cash: root.getAttribute('data-cash-caption') || 'Vehicle Price',
      finance: root.getAttribute('data-finance-caption') || 'Est. Financing'
    };
    var monthSuffix = root.getAttribute('data-month-suffix') || '/mo';
    var currentTerm = Number(root.getAttribute('data-term-default') || 72);
    var fixedApr = cleanNumber(root.getAttribute('data-apr-default'));
    var downDefault = cleanNumber(root.getAttribute('data-down-default'));

    if (termSelect) termSelect.value = String(currentTerm);
    if (downInput) downInput.value = String(downDefault);
    if (modalApr) modalApr.textContent = fixedApr.toFixed(2).replace(/\.00$/, '') + '%';

    function calculateMonthly(price) {
      var down = cleanNumber(downInput ? downInput.value : downDefault);
      var months = currentTerm > 0 ? currentTerm : 72;
      var principal = Math.max(price - down, 0);
      if (fixedApr <= 0) return principal / months;
      var monthlyRate = fixedApr / 100 / 12;
      return principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -months));
    }

    function getMode() {
      return root.getAttribute('data-current-mode') || 'cash';
    }

    function getSelectedOption(group) {
      return root.querySelector('[data-bs-group="' + group + '"].is-selected');
    }

    function getBaseOption() {
      return getSelectedOption('model') || root.querySelector('[data-bs-option]');
    }

    function getSelectedAddonsTotal() {
      var total = 0;
      root.querySelectorAll('[data-bs-option].is-selected').forEach(function (option) {
        if (option.getAttribute('data-bs-group') !== 'model') {
          total += cleanNumber(option.getAttribute('data-cash-number'));
        }
      });
      return total;
    }

    function getTotalCashPrice() {
      var base = getBaseOption();
      return cleanNumber(base ? base.getAttribute('data-cash-number') : 0) + getSelectedAddonsTotal();
    }

    function displayPrice(cash) {
      return getMode() === 'finance' ? formatMoney(calculateMonthly(cash)) : formatMoney(cash);
    }

    function updateModeButtons() {
      var mode = getMode();
      modeButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-bs-mode') === mode);
      });
      modalModeButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-bs-modal-mode') === mode);
      });
    }

    function updateOptionPrices() {
      options.forEach(function (option) {
        var priceSlot = option.querySelector('[data-bs-option-price]');
        if (!priceSlot) return;
        var cash = cleanNumber(option.getAttribute('data-cash-number'));
        priceSlot.innerHTML = '';
        priceSlot.appendChild(document.createTextNode(displayPrice(cash)));
        if (getMode() === 'finance') {
          var small = document.createElement('small');
          small.textContent = ' ' + monthSuffix;
          priceSlot.appendChild(small);
        }
      });
    }

    function updateFinanceSummary() {
      if (!financeSummaryText) return;
      var down = cleanNumber(downInput ? downInput.value : downDefault);
      financeSummaryText.textContent =
        fixedApr.toFixed(2).replace(/\.00$/, '') +
        '% APR, ' +
        formatMoney(down) +
        ' down, ' +
        currentTerm +
        ' mo';
    }

    function updateStickyAndModal() {
      var mode = getMode();
      var total = getTotalCashPrice();
      var currentDisplay = displayPrice(total);
      if (stickyPrice) stickyPrice.textContent = currentDisplay;
      if (stickySuffix) stickySuffix.textContent = mode === 'finance' ? ' ' + monthSuffix : '';
      if (stickyCaption) stickyCaption.textContent = captions[mode] || captions.cash;
      if (modalPayment) modalPayment.textContent = currentDisplay;
      if (modalPaymentSuffix) modalPaymentSuffix.textContent = mode === 'finance' ? monthSuffix : '';
    }

    function updateOrderLink() {
      if (!orderLink) return;
      var base = getBaseOption();
      var url = base ? base.getAttribute('data-order-url') : '';
      if (url) orderLink.setAttribute('href', url);
    }

    function refresh() {
      updateModeButtons();
      updateOptionPrices();
      updateFinanceSummary();
      updateStickyAndModal();
      updateOrderLink();
    }

    function setMode(mode) {
      root.setAttribute('data-current-mode', mode);
      refresh();
    }

    function selectOption(option) {
      var group = option.getAttribute('data-bs-group') || 'model';
      root.querySelectorAll('[data-bs-group="' + group + '"]').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      option.classList.add('is-selected');
      refresh();
    }

    function openFinancingModal() {
      closeCompareModal();
      root.classList.add('is-financing-modal-open');
      root.querySelector('[data-bs-financing-modal]').setAttribute('aria-hidden', 'false');
      setMode('finance');
    }

    function closeFinancingModal() {
      root.classList.remove('is-financing-modal-open');
      root.querySelector('[data-bs-financing-modal]').setAttribute('aria-hidden', 'true');
    }

    function openCompareModal() {
      closeFinancingModal();
      root.classList.add('is-compare-modal-open');
      root.querySelector('[data-bs-compare-modal]').setAttribute('aria-hidden', 'false');
    }

    function closeCompareModal() {
      root.classList.remove('is-compare-modal-open');
      root.querySelector('[data-bs-compare-modal]').setAttribute('aria-hidden', 'true');
    }

    modeButtons.forEach(function (button) {
      button.addEventListener('click', function () { setMode(button.getAttribute('data-bs-mode')); });
    });

    modalModeButtons.forEach(function (button) {
      button.addEventListener('click', function () { setMode(button.getAttribute('data-bs-modal-mode')); });
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () { selectOption(option); });
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectOption(option);
        }
      });
    });

    if (downInput) downInput.addEventListener('input', refresh);
    if (termSelect) {
      termSelect.addEventListener('change', function () {
        currentTerm = Number(termSelect.value) || currentTerm;
        refresh();
      });
    }

    openFinancingButtons.forEach(function (button) {
      button.addEventListener('click', openFinancingModal);
    });
    closeFinancingButtons.forEach(function (button) {
      button.addEventListener('click', closeFinancingModal);
    });
    openCompareButtons.forEach(function (button) {
      button.addEventListener('click', openCompareModal);
    });
    closeCompareButtons.forEach(function (button) {
      button.addEventListener('click', closeCompareModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-financing-modal-open')) {
        closeFinancingModal();
      }
      if (event.key === 'Escape' && root.classList.contains('is-compare-modal-open')) {
        closeCompareModal();
      }
    });

    setMode(root.getAttribute('data-current-mode') || 'cash');
  }

  function boot() {
    document.querySelectorAll('[data-bs-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
